<template>
  <v-app v-if="active && this.moduleActive && !blockPage">
    <v-container fluid class="pt-5">
      <v-card class="overflow-hidden">
        <v-app-bar
            color="white"
            elevation=""
            fixed
            scroll-target="#scrolltarget"
        >
          <v-app-bar-nav-icon class="primary--text" v-if="drawer" @click.stop="$emit('open-drawer')"></v-app-bar-nav-icon>

          <v-toolbar-title class="primary--text text-overline pl-1">{{ appName }}</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-avatar>
            <v-img :src="logo"/>
          </v-avatar>

          <template v-if="$slots['nav']" v-slot:extension>
            <slot name="nav" />
          </template>

        </v-app-bar>
        <v-sheet
            id="scrolltarget"
            style="margin-top: 80px"
        >
          <slot />
        </v-sheet>
      </v-card>
    </v-container>

    <slot name="navDrawer"></slot>
    <slot name="order"></slot>
  </v-app>
  <v-app v-else-if="blockPage">
    <v-container fluid class="pt-5">
      <v-alert
          outlined
          type="info"
          border="left"
      >
        É necessário atualizar a página para continuar.
      </v-alert>
    </v-container>
  </v-app>
  <v-app v-else>
    <v-container fluid class="pt-5">
      <v-alert
          outlined
          type="warning"
          border="left"
      >
        Este recurso não está disponível
      </v-alert>
    </v-container>
  </v-app>
</template>

<script>
import {initializeApp} from "@firebase/app";
import { getAnalytics } from "@firebase/analytics";

export default {
  name: "BasePage",
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: true
    }
  },
  metaInfo: {
    title: _theme.pageTitle
  },

  data: vm => {
    return {
      appName: _theme.appName,
      logo: _theme.logo,
      openDrawer: false,
      categorySelected: null,
      moduleActive: _config.active,
      blockPage: false
    }
  },
  created() {
    this.$vuetify

    if (this.moduleActive) {
      const firebaseConfig = _config.firebase_web_credentials

      const app = initializeApp(firebaseConfig)
      const analytics = getAnalytics(app);
      const vm = this;

      addEventListener("storage", (event) => {
        const appId = JSON.parse(localStorage.getItem('cart'))['app_id']
        if (_config['app_id'] !== appId) {
          //Bloquear a página, forçando refresh automático do usuário
          vm.blockPage = true;
        }
      });
    }
  },
  watch: {
    categorySelected () {
      this.openDrawer = false
    },
  },
}
</script>

<style>
</style>